import React, { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import styles from './Login.module.scss';
import { Button, Textfield } from '@/components/atomics';
import Icon from '@/components/atomics/Icons';
import { useAuth } from '@/hooks/useAuth';
import MessageError from '@/components/atomics/MessageError';

const className = 'login';

const Login: React.FC = () => {
  const [username, setUsername] = React.useState<string>('');
  const [password, setPassword] = React.useState<string>('');
  const [err, setErr] = React.useState<boolean>(false);
  const navigate = useNavigate();

  const { data, error, refetch } = useAuth({ username, password });

  useEffect(() => {
    if (error) {
      setErr(true);
    }
  }, [error]);

  useEffect(() => {
    if (!data) return;
    if (data?.level < 3) {
      navigate('/dashboard');
    } else if (data?.level === 3) {
      navigate('/list-feedback');
    }
  }, [data]);

  const handleChangeUsername = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    setUsername(event.target.value);
  }, []);

  const handleChangePassword = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(event.target.value);
  }, []);

  const handleSubmit = async () => {
    if (username && password) {
      refetch();
    }
  };

  return (
    <div className={styles[className]}>
      <div className={styles[className + '__cover']}>
        <span className={styles[className + '__cover_overlay']} />
      </div>
      <div className={styles[className + '__form']}>
        {err && <MessageError>
          Kombinasi username / password yang Anda masukan salah, silahkan ulangi
        </MessageError>}
        <h5 className={styles[className + '__form_title']}>
          Selamat datang di Antares Eazy
        </h5>
        <label className={styles[className + '__form_subtitle']}>
          Silahkan masuk dengan menggunakan akun Anda.
        </label>
        <Textfield
          iconLeft={<Icon name="People" />}
          name="username" onChange={handleChangeUsername}
          placeholder="Username"
          type="text"
        />
        <Textfield
          iconLeft={<Icon name="Key" />}
          placeholder="Password" onChange={handleChangePassword}
          type="password"
        />
        <Button disabled={username === '' || password === ''} onClick={() => {
          handleSubmit();
        }} type="submit">
          Login
        </Button>
        <div className={styles[className + '__form_footer']}>
          Copyright © {moment().format('YYYY')} <b>Antares Eazy</b>. All rights reserved.
        </div>
      </div>
    </div>
  );
};

export default Login;